import React from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    EditButton,
    Filter,
    List,
    TextField,
    TextInput,
} from 'react-admin';

const ThreadFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Title" source="title" alwaysOn />
        <TextInput label="Link" source="link" alwaysOn />
    </Filter>
);

export const ThreadList = (props) => (
    <List {...props} filters={<ThreadFilter />} sort={{ field: 'createdAt', order: 'DESC' }} bulkActionButtons={false}>
        <Datagrid>
            <TextField label="Title" source="title" />
            <BooleanField label="Closed?" source="closed" />
            <DateField disabled label="Last Updated" source="updated_at" showTime sortBy="updatedAt" />
            <DateField disabled label="Created" source="created_at" showTime sortBy="createdAt" />
            <DateField disabled label="Deleted" source="deleted_at" showTime sortBy="deletedAt" />
            <EditButton />
        </Datagrid>
    </List>
);
